export default __webpack_public_path__ + "static/media/wct.22db9cf2.png";